import type React from "react";
import { Group, Text } from "@mantine/core";

/** One `label: value` pair. */
export type Field = readonly [label: string, value: string];

interface FieldListProps {
  fields: readonly Field[];
}

/** Fields as `Label: value` pairs that wrap onto as many lines as they need. */
const FieldList: React.FC<FieldListProps> = ({ fields }) => {
  if (fields.length === 0) return null;
  return (
    <Group gap="lg" style={{ rowGap: 4 }}>
      {fields.map(([label, value]) => (
        <Text key={label} size="sm" className="field-value">
          <Text span size="sm" c="dimmed">
            {label}:
          </Text>{" "}
          {value}
        </Text>
      ))}
    </Group>
  );
};

export default FieldList;
